import { Typography } from "@mui/material";
import { ReactElement } from "react";

export const PageHeader = ({
  children,
  isSlim = false,
}: {
  children: React.ReactNode;
  isSlim?: boolean;
}): ReactElement => {
  return (
    <Typography
      variant="display0Bold"
      sx={{ pb: isSlim ? 0.5 : 2 }}
      component="div"
    >
      {children}
    </Typography>
  );
};
